import { useCallback, useEffect, useRef } from 'react';

const useValidationRegistry = () => {
  const validatorsRef = useRef({});

  const registerValidation = useCallback((name, validator) => {
    if (!name) return;

    if (typeof validator !== 'function') {
      delete validatorsRef.current[name];
      return;
    }

    validatorsRef.current[name] = validator;
  }, []);

  const validateAll = useCallback(() => {
    let allValid = true;

    Object.entries(validatorsRef.current).forEach(([, validator]) => {
      try {
        if (validator() !== true) {
          allValid = false;
        }
      } catch (error) {
        allValid = false;
      }
    });

    return allValid;
  }, []);

  useEffect(
    () => () => {
      validatorsRef.current = {};
    },
    []
  );

  return {
    registerValidation,
    validateAll,
  };
};

export default useValidationRegistry;
